import { makeStyles } from "@fluentui/react-components";
import * as React from "react";

// components
import { Spinner } from "@fluentui/react-components";

const useStyles = makeStyles({
  backdrop: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
});

export const SpinnerWithBackdrop = (props: React.ComponentProps<typeof Spinner>) => {
  const styles = useStyles();

  return (
    <div className={styles.backdrop}>
      <Spinner size="large" {...props} />
    </div>
  );
};
